import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import dayjs from 'dayjs';
import { UserContext } from './App';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { UserItem } from '#/services/UserService';
import NotificationService, {
  NotificationItem,
  NotificationData,
} from '#/services/NotificationService';
import * as URI from 'urijs';
import { Pagenate, PagenateData } from './parts/Pagenate';
import { SpinnerView } from './parts/SpinnerView';
import { PAGE_SIZE } from '#/config/constant';
import { FilterView } from './parts/FilterView';

export function NotificationTable(
  userInfo: UserItem,
  data: NotificationItem[] | undefined
) {
  let items = [<></>];

  if (data === undefined) {
    items = [
      <tr key={'spinner'}>
        <td colSpan={5}>
          <SpinnerView />
        </td>
      </tr>,
    ];
  } else if (data.length > 0) {
    items = data.map((notify) => {
      return (
        <tr key={notify.owner_id}>
          <td>{dayjs(notify.notify_at).format('YYYY-MM-DD HH:mm:ss')}</td>
          <td>
            {['admin', 'superuser'].includes(userInfo.role) ? (
              <Link to={`/owner/${notify.owner_id}`}>{notify.owner_id}</Link>
            ) : (
              notify.owner_id
            )}
          </td>
          <td>
            <Link to={`/child/${notify.child_id}`}>{notify.child_id}</Link>
          </td>
          <td>
            {userInfo.role === 'superuser' ? (
              <Link to={`/admin/${notify.admin_id}`}>{notify.admin_id}</Link>
            ) : (
              notify.admin_id
            )}
          </td>
          <td>
            <Link to={`/user/${notify.user}`}>{notify.user}</Link>
          </td>
        </tr>
      );
    });
  } else {
    items = [
      <tr key={'no-data'} className="text-center">
        <td colSpan={5}>データがありません</td>
      </tr>,
    ];
  }

  return (
    <Table className="mb-0">
      <thead>
        <tr>
          <th className="text-center">通知日時</th>
          <th className="text-center">親機ID</th>
          <th className="text-center">子機ID</th>
          <th className="text-center">管理者</th>
          <th className="text-center">ユーザ</th>
        </tr>
      </thead>
      <tbody>{items}</tbody>
    </Table>
  );
}

function Notification() {
  const ctx = useContext(UserContext);
  const [notifications, setNotifications] = useState<NotificationItem[]>();
  const service = new NotificationService(ctx.userInfo!);
  const uri = new URI.default(window.location.href);
  const [page, setPage] = useState<PagenateData>({
    total: 0,
    page: Number(uri.query(true)['page'] || 0),
    size: PAGE_SIZE,
  });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setNotifications(undefined);

    service
      .getList({
        ...uri.query(true),
        ...page,
      })
      .then(
        (res: NotificationData) => {
          setPage({ ...page, ...res.page });
          setNotifications(res.data);
        },
        (e) => {
          if (e?.response.status === 401) {
            navigate(0);
          }
        }
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-1">
            <div className="row align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row>
              <Col>
                <FilterView
                  date_range={'通知日'}
                  owner_id={true}
                  child_id={true}
                  admin_id={true}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Pagenate {...page} />
              </Col>
            </Row>
            <Row className="mt-3 border">
              <Col className="p-2">
                {NotificationTable(ctx.userInfo!, notifications)}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default Notification;
